import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { CapitalizeFirstPipe } from 'src/app/shared/pipes/capitalize-first.pipe';
import { WordWrapPipe } from 'src/app/shared/pipes/word-wrap.pipe';
// Third Party
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
// functions
import {
  concatenateCompanyStreetAddress,
  concatenateCompanyCityStateAddress,
  concatenateCustomerStreetAddress,
  concatenateCustomerCityStateAddress,
  generatePDF,
} from 'src/app/shared/functions';
import { Customer, SalesReceipt, SalesReceiptPrint } from 'src/app/shared/models/accounting';
import { ModalID } from 'src/app/shared/models/constants';
// Services
import { SharedService } from 'src/app/shared/services/shared.service';
import { AccountingService } from '../services/accounting.service';
//import { StartupService } from 'src/app/services/startup.service';
import { SalesReceiptPdfGenerator } from './create-sales-receipt-pdf';

@Component({
    selector: 'app-sales-receipt-print',
    templateUrl: './sales-receipt-print.component.html',
    styleUrls: ['./sales-receipt-print.component.scss'],
    standalone: true,
    imports: [DatePipe, CapitalizeFirstPipe, WordWrapPipe]
})
export class SalesReceiptPrintComponent implements OnInit {
  @ViewChild('receipt') receipt: ElementRef;
  private pdfGenerator = new SalesReceiptPdfGenerator();
  sales_receipt: SalesReceipt;
  jsPDF: any;
  company_street_address = concatenateCompanyStreetAddress(
    this.sharedService.company_info // account_information.company
  );
  company_city_state_zip = concatenateCompanyCityStateAddress(
    this.sharedService.company_info
  );
  customer_info: Customer;
  customer_street_address: string;
  customer_city_state_zip: string;
  modalRef: BsModalRef;
  modalConfig = { animated: true };

  get receiptTitle(): string {
    const companyName = this.sharedService.company_info?.company_name?.trim();
    const legalName = this.sharedService.company_info?.legal_name?.trim();
    const titlePrefix = companyName || legalName;
    return titlePrefix ? `${titlePrefix} Sales Receipt` : 'Sales Receipt';
  }

  constructor(
    protected element: ElementRef,
    private modalService: BsModalService,
    public sharedService: SharedService,
    public accountingService: AccountingService,
   // public startupService: StartupService,
  ) {}
  ngOnInit(): void {
    this.getCustomerInfo(this.sales_receipt.customer_id);
  }

  getCustomerInfo(customer_id: string) {
    this.customer_info = this.accountingService.getCustomerInfo(customer_id);
    this.customer_street_address = concatenateCustomerStreetAddress(
      this.customer_info
    );
    this.customer_city_state_zip = concatenateCustomerCityStateAddress(
      this.customer_info
    );
  }

  closeModalClick(): void {
    this.modalService.hide(ModalID.sales_receipt_print);
  }

  async printReceiptClick() {
    const doc = this.pdfGenerator.generateReceiptPdf(
      this.sales_receipt,
      this.sharedService.company_info,
      await this.sharedService.getCompanyLogoDataUri(),
    );
    this.pdfGenerator.savePdfFile(doc, this.sales_receipt, this.sharedService.company_info);
    this.closeModalClick();
  }
}
